import { forwardRef } from "react";
import { getLocalizedString } from "../../utils";
import { Box, Flex } from "rebass";
import Search from "../../icons/Search";
import useResponsive from "../../hooks/useResponsive";
import Tooltip from "./Tooltip";

const SearchInput = forwardRef(({ onSubmit, sx, button, ...props }, ref) => {
  const { breakpoint } = useResponsive();
  const {
    sx: buttonSx,
    tooltip,
    ...buttonProps
  } = button || { sx: {}, tooltip: getLocalizedString("SEARCH") };
  return (
    <Flex
      sx={{
        position: "relative",
        ...sx,
      }}
    >
      <input
        ref={ref}
        type="text"
        tabIndex={"-1"}
        placeholder={
          getLocalizedString("Search filter").charAt(0).toUpperCase() +
          getLocalizedString("Search filter").toLowerCase().slice(1)
        }
        {...props}
        style={{
          width: "100%",
          height: "40px",
          paddingLeft: "8px",
          paddingRight: breakpoint(["26px", "32px"]),
          flexGrow: 1,
          fontSize: ".8em",
          lineHeight: ".8em",
          ...props.style,
        }}
      />
      <Box
        onClick={onSubmit}
        sx={{
          position: "absolute",
          top: "1px",
          bottom: "1px",
          right: ["2px", "4px"],
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          ...buttonSx,
        }}
        {...buttonProps}
      >
        <Tooltip content={tooltip}>
          <Box paddingTop={"3px"}>
            <Search
              style={{
                width: breakpoint(["20px", "24px"]),
                height: breakpoint(["20px", "24px"]),
              }}
            />
          </Box>
        </Tooltip>
      </Box>
    </Flex>
  );
});

export default SearchInput;
